// import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Http } from '@angular/http';

@Injectable()
export class YoutubeProvider {
	apiKey = 'AIzaSyACnv5vJFptpjX_ra11jlD31Ci1zXbdKyY';

	constructor(
		public http: Http) {
	}

	getPlaylistsForChannel(channel) {
		return this.http.get('https://www.googleapis.com/youtube/v3/playlists?key=' + this.apiKey + '&channelId=' + channel + '&part=snippet,id&maxResults=20')
			.map((res) => {
				return res.json()['items'];
			})
	}

	getListVideos(listId) {
		return this.http.get('https://www.googleapis.com/youtube/v3/playlistItems?key=' + this.apiKey + '&playlistId=' + listId + '&part=snippet,id&maxResults=20')
			.map((res) => {
				return res.json()['items'];
			})
	}


	getChannelList(channel) {
		return this.http.get('https://www.googleapis.com/youtube/v3/channels?key=' + this.apiKey + '&id=' + channel + '&part=snippet,id&maxResults=20')
			.map((res) => {
				return res.json()['items'];
			})
	}


}



// WEBPACK FOOTER //
// ./src/providers/youtube.ts